<div class="container content-box module-content">
  <div id="activity1">
      <h3>Activity: Landlord or Neighbor: Who Should I Talk To About My Problem? </h3>
      <form class="radio wrapper">
          <!-- 1 -->
          <div class="question1">
              <br> <b> My sink is leaking.</b> <br>
              <input id="question1_1" name="question1" type="radio" [value]="true" [(ngModel)]="model.question1" (click)="question1()"> <label for="question1_1">Neighbor</label><br/>
              <input id="question1_2" name="question1" type="radio" [value]="false" [(ngModel)]="model.question1" (click)="question1()"> <label for="question1_2">Landlord</label><br/>
              <div *ngIf="model.question1 && question1Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;You answered Neighbor, that is wrong.
              </div>
              <div *ngIf="!model.question1  && question1Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;You answered Landlord, that is correct.
              </div>
          </div>
          <!-- 2 -->
          <div class="question2">
              <br> <b>Children are running in the hallways.</b> <br>
              <input id="question2_1" name="question2" type="radio" [value]="false" [(ngModel)]="model.question2" (click)="question2()"> <label for="question2_1">Neighbor</label><br/>
              <input id="question2_2" name="question2" type="radio" [value]="true" [(ngModel)]="model.question2" (click)="question2()"> <label for="question2_2">Landlord</label><br/>
              <div *ngIf="model.question2 && question2Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;You answered Landlord, that is wrong.
              </div>
              <div *ngIf="!model.question2  && question2Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;You answered Neighbor, that is correct
              </div>
          </div>
          <!-- 3 -->
          <div class="question3">
              <br> <b> Loud music is coming from next door.</b> <br>
              <input id="question3_1" name="question3" type="radio" [value]="false" [(ngModel)]="model.question3" (click)="question3()"> <label for="question3_1">Neighbor</label><br/>
              <input id="question3_2" name="question3" type="radio" [value]="true" [(ngModel)]="model.question3" (click)="question3()"> <label for="question3_2">Landlord</label><br/>
              <div *ngIf="model.question3 && question3Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;You answered Landlord, that is wrong.
              </div>
              <div *ngIf="!model.question3  && question3Picked" style="background-color: rgba(0, 128, 0, 0.25); font-weight: bolder;">
                  &nbsp;You answered Neighbor, that is correct.
              </div>
          </div>
          <!-- 4 -->
          <div class="question4">
              <br> <b> There is not enough parking. </b> <br>
              <input id="question4_1" name="question4" type="radio" [value]="true" [(ngModel)]="model.question4" (click)="question4()"> <label for="question4_1">Neighbor</label><br/>
              <input id="question4_2" name="question4" type="radio" [value]="false" [(ngModel)]="model.question4" (click)="question4()"> <label for="question4_2">Landlord</label><br/>
              <div *ngIf="model.question4 && question4Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;You answered Neighbor, that is wrong.
              </div>
              <div *ngIf="!model.question4  && question4Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;You answered Landlord, that is correct.
              </div>
          </div>
          <!-- 5 -->
          <div class="question5">
              <br> <b> Security doors are broken.</b> <br>
              <input id="question5_1" name="question5" type="radio" [value]="true" [(ngModel)]="model.question5" (click)="question5()"> <label for="question5_1">Neighbor</label><br/>
              <input id="question5_2" name="question5" type="radio" [value]="false" [(ngModel)]="model.question5" (click)="question5()"> <label for="question5_2">Landlord</label><br/>
              <div *ngIf="model.question5 && question5Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;You answered Neighbor, that is wrong.
              </div>
              <div *ngIf="!model.question5  && question5Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;You answered Landlord, that is correct.
              </div>
          </div>
          <!-- 6 -->
          <div class="question6">
              <br> <b>Garbage is being left in the hallway. </b> <br>
              <input id="question6_1" name="question6" type="radio" [value]="false" [(ngModel)]="model.question6" (click)="question6()"> <label for="question6_1">Neighbor</label><br/>
              <input id="question6_2" name="question6" type="radio" [value]="true" [(ngModel)]="model.question6" (click)="question6()"> <label for="question6_2">Landlord</label><br/>
              <div *ngIf="model.question6 && question6Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;You answered Landlord, that is wrong.
              </div>
              <div *ngIf="!model.question6  && question6Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;You answered Neighbor, that is correct.
              </div>
          </div>
          <!-- 7 -->
          <div class="question7">
              <br> <b> My toilet keeps running after it is flushed. </b> <br>
              <input id="question7_1" name="question7" type="radio" [value]="true" [(ngModel)]="model.question7" (click)="question7()"> <label for="question7_1">Neighbor</label><br/>
              <input id="question7_2" name="question7" type="radio" [value]="false" [(ngModel)]="model.question7" (click)="question7()"> <label for="question7_2">Landlord</label><br/>
              <div *ngIf="model.question7 && question7Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;You answered Neighbor, that is wrong.
              </div>
              <div *ngIf="!model.question7  && question7Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;You answered Landlord, that is correct.
              </div>
          </div>
          <!-- 8 -->
          <div class="question8">
              <br> <b> Security doors are often propped up. </b> <br>
              <input id="question8_1" name="question8" type="radio" [value]="false" [(ngModel)]="model.question8" (click)="question8()"> <label for="question8_1">Neighbor</label><br/>
              <input id="question8_2" name="question8" type="radio" [value]="true" [(ngModel)]="model.question8" (click)="question8()"> <label for="question8_2">Landlord</label><br/>
              <div *ngIf="model.question8 && question8Picked" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;You answered Landlord, that is wrong.
              </div>
              <div *ngIf="!model.question8  && question8Picked" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;You answered Neighbor, that is correct.
              </div>
          </div>
          <div *ngIf="flag" style="color:red" class="warning">
              You must answer all questions correctly before moving on
          </div>
      </form>
  </div>
</div>

<div class="container navigate-buttons">
  <button type="button" class="btn waves-dark w-25" (click)="goBack($event); resetFlag();"><i class="fas fa-angle-left mr-3"></i>{{backTitle}}</button>
  <button *ngIf="previewByAdmin || !delay || activityOneCorrect()" type="button" class="btn waves-dark w-25" (click)="goNext($event) && resetFlag();">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
  <button *ngIf="!(previewByAdmin || !delay || activityOneCorrect())" type="button" class="btn waves-dark w-25" (click)="setFlag()" style="background-color: #ffd782;">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
</div>
